<template>
  <div class="dynamics">

    <div class="img">
      <img :src="item.url" alt="">
    </div>
   <div class="cont">
    <div class="title">{{ item.title }}</div>
    <div class="time">{{ item.publishDate }}</div>
    <div class="desc" v-html="item.introduction"></div>
   </div>
   <img class="more default" src="https://www.xaryxx.com/images/detail.png" alt="">
  
  </div>
</template>

<script>
export default {
  name: "company-dynamics",
  props: {
    item:{
      type: Object,
      default:{}
    },
    times: {
      default: function () {
        let _times = new Date();
        const _year = _times.getFullYear();
        const _month = _times.getMonth() >= 9 ? (_times.getMonth() + 1) : '0' + (_times.getMonth() + 1);
        const _date = _times.getDate() > 9 ? _times.getDate() : '0' + _times.getDate();
        const _h = _times.getHours() > 9 ? _times.getHours() : '0' + _times.getHours();
        const _m = _times.getMinutes() > 9 ? _times.getMinutes() : '0' + _times.getMinutes();
        const _s = _times.getSeconds() > 9 ? _times.getSeconds() : '0' + _times.getSeconds();

        return _year + '-' + _month + '-' + _date + ' ' + _h + ':' + _m + ':' + _s
      }
    },
    title: {
      type: String,
      default: ""
    },
    text: {
      type: String,
      default: ""
    }
  },
  computed: {
    months() {
      let months = new Date(this.times).getMonth() + 1;
      let days = new Date(this.times).getDate();

      let _months = months >= 10 ? months : '0' + months;
      let _days = days >= 10 ? days : '0' + days;
      return _months + ' - ' + _days;
    },
    years() {
      return new Date(this.times).getFullYear();
    }
  }
};
</script>

<style lang="less" scoped>
.dynamics{
  flex: 1;
  display: flex;
  
  justify-content: space-between;
  .img{
    width: 356px;
    height: 200px;
    img{
      width: 100%;
      height: 200px;
      border-radius: 4px;
    }
  }
  .more{
    width: 40px;
    height: 40px;
    align-self: center;
  }
  .cont{
    flex: 1;
  }
  .title {
      min-height: 50px;
      font-size: 18px;
      font-family: PingFang SC-Semibold, PingFang SC;
      font-weight: 600;
      color: #333333;
      padding:0 20px 0;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box; //必须结合的属性，将对象作为弹性伸缩盒子模型显示
      -webkit-line-clamp: 2; //控制文本的行数
      -webkit-box-orient: vertical; //必须结合的属性，设置或检索伸缩盒对象的子元素的排列方式
    }

    .desc {
      padding: 0 20px;
      font-size: 16px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
      // line-height: 23px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box; //必须结合的属性，将对象作为弹性伸缩盒子模型显示
      -webkit-line-clamp: 2; //控制文本的行数
      -webkit-box-orient: vertical; //必须结合的属性，设置或检索伸缩盒对象的子元素的排列方式
    }

    .time {

      font-size: 16px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
      line-height: 23px;
      padding: 8px 20px;
    }
    cursor: pointer;
    padding: 20px;
    .active{
      display: none;
    }
    &:hover{
      background: #F2F9FB;
      .title{
        color: #F64723;
      }
      .active{
        display: block;
      }
      .default{
        display: none;
      }
    }
}
// .dynamics {
//   display: flex;

//   .dynamics-left {
//     display: flex;
//     flex: 0 0 130px;
//     font-size: 28px;
//     color: #333333;
//     border-right: 2px solid #333333;
//     // color: #17bbc5;
//     // border-right: 2px solid #17bbc5;
//     flex-direction: column;
//     align-items: center;
//     justify-content: center;

//     .left-month {
//       margin-left: -30px;
//       font-size: 28px;
//       padding-bottom: 10px;
//     }

//     .left-year {
//       margin-right: -50px;
//       font-size: 16px;
//       padding-bottom: 5px;
//     }

//     .left-icon {
//       img {
//         width: 20px;
//         height: 20px;
//         margin-right: -65px;
//       }
//     }
//   }

//   .dynamics-right {
//     margin-left: 40px;
//     text-align: left;

//     .title {
//       //   margin-top: 10px;
//       // color: #17bbc5;
//       color: #333333;
//       font-size: 18px;
//     }

//     .text {
//       font-size: 16px;
//       color: #666666;
//       margin: 15px 0;
//     }
//   }
// }

// .dynamics:hover {
//   .dynamics-left {
//     color: #17bbc5;
//     border-right: 2px solid #17bbc5;
//   }

//   .dynamics-right {
//     .title {
//       color: #17bbc5;
//     }
//   }
// }


</style>



// WEBPACK FOOTER //
// src/components/common/company-dynamics.vue